<mat-form-field fxFlex>
    <mat-label>Search</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="text"
    [(ngModel)]="searchText"
    placeholder="Search"
    (ngModelChange)="onSearchTextChanged()"/>
  </mat-form-field>
